import i18n from "../helpers/i18n";
import Vue from 'vue'
const _swal = Vue.swal;
const notFill = () => {
    _swal.fire({
        icon: "warning",
        title: i18n.tc('message.warning.title'),
        text: i18n.tc('message.notFill'),
    });
}

const messageSuccess = ({ action, type }) => {
    _swal.fire({
        icon: "success",
        title: i18n.t(`message.title.${action}`, { type: type }),
        text: i18n.t(`message.success.${action}`, { type: type }),
    });
};

const messageError = ({ action, type, response }) => {
    _swal.fire({
        icon: "error",
        title: i18n.t(`message.error.${action}`, { type: type }),
        text: response,
    });
};

const confirmDelete = ({ type }) => {
    return _swal({
        title: i18n.t('message.title.delete', { type: type }),
        text: i18n.t('message.title.question'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: i18n.t('button.yes'),
        cancelButtonText: i18n.t('button.exit'),
        showCloseButton: true,
    })
}

const messageDangKyFalse = (num) => {
    switch (num) {
        case 1:
            _swal
                .fire({
                    icon: "error",
                    title: i18n.t('models.dotDangKy.titleChuaBd'),
                    text: i18n.t('models.dotDangKy.textChuaBd')
                });
            break;
        case 2:
            _swal.fire({
                icon: "error",
                title: i18n.t('models.dotDangKy.titleQuaHan'),
                text: i18n.t('models.dotDangKy.textQuaHan')
            });
            break;
        case 3:
            _swal.fire({
                icon: "error",
                title: i18n.t('models.dotDangKy.titleKhongTonTai'),
                text: i18n.t('models.dotDangKy.textKhongTonTai'),
            });
            break;
        case 4:
            _swal.fire({
                icon: "error",
                title: i18n.t('models.dotDangKy.titleLoiDangKy'),
                text: i18n.t('models.dotDangKy.textLoiDangKy'),
            });
            break;
        case 5:
            _swal.fire({
                icon: "error",
                title: i18n.t('models.dotDangKy.titleChuaCongBo'),
                text: i18n.t('models.dotDangKy.textChuaCongBo'),
            });
            break;
    }
}

const messageLoiDangKy = (response) => {
    _swal.fire({
        icon: "error",
        title: i18n.t('models.dotDangKy.titleLoiDangKy'),
        text: response,
    });
}

const messageErrorServer = (response) => {
    _swal.fire({
        icon: "error",
        title: response.title,
        text: response.message,
    });
}

const trungKhaoSat = () => {
    _swal.fire({
        icon: "warning",
        title: i18n.t('.khaoSat.titleTrung'),
        text: i18n.t('message.khaoSat.textKhongTonTai'),
    })
}

const messageTrungNganh = () => {
    _swal.fire({
        icon: "warning",
        title: i18n.t('message.nganh.titleTrungNganh'),
        text: i18n.t('message.nganh.textTrungNganh'),
    })
}

const messageErrorCapNhapThongTin = () => {
    _swal.fire({
        icon: "error",
        title: i18n.t('message.capNhat.titleLoiCapNhat'),
        html: i18n.t('message.capNhat.textLoiCapNhat'),
    });
}

const confirmEditThiSinh = () => {
    return _swal.fire({
        icon: "info",
        title: i18n.t('models.dotDangKy.edit'),
        text:
            i18n.t('models.dotDangKy.confirmEdit'),
        showCancelButton: true,
        confirmButtonColor: "#007bff",
        confirmButtonText: i18n.t('button.yes'),
        cancelButtonText: i18n.t('button.back'),
    });
}

const confirmEditThiSinhExist = () => {
    return _swal.fire({
        icon: "info",
        title: i18n.t('models.dotDangKy.sttDangKy'),
        text:
            i18n.t('models.dotDangKy.confirmEditExist'),
        showCancelButton: true,
        confirmButtonColor: "#007bff",
        confirmButtonText: i18n.t('button.yes'),
        cancelButtonText: i18n.t('button.back'),
    });
}

const messageDaTrungTuyen = () => {
    _swal.fire({
        icon: "warning",
        title: i18n.t('message.trungTuyen.titleDaTrungTuyen'),
        text: i18n.t('message.trungTuyen.textDaTrungTuyen'),
    })
}

const messageErrorTraCuu = () => {
    _swal.fire({
        icon: "warning",
        title: i18n.t('message.traCuu.titleLoiTraCuu'),
        text: i18n.t('message.traCuu.textLoiTraCuu'),
    })
}

const messageErrorNhapHoc = (num) => {
    switch (num) {
        case 1:
            _swal.fire({
                icon: "warning",
                title: i18n.t('message.nhapHoc.titleChuaCongBo'),
                text: i18n.t('message.nhapHoc.textChuaCongBo'),
            });
            break;
        case 2:
            _swal.fire({
                icon: "warning",
                title: i18n.t('message.nhapHoc.titleChuaNhapHoc'),
                text: i18n.t('message.nhapHoc.textChuaNhapHoc'),
            });
            break;
        case 3:
            _swal.fire({
                icon: "warning",
                title: i18n.t('message.nhapHoc.titleQuaHan'),
                text: i18n.t('message.nhapHoc.textQuaHan'),
            });
            break;
        case 4:
            _swal.fire({
                icon: "warning",
                title: i18n.t('message.nhapHoc.titleDaNhapHoc'),
                html: i18n.t('message.nhapHoc.textDaNhapHoc'),
            });
            break;
        case 5:
            _swal.fire({
                icon: "warning",
                title: i18n.t('message.nhapHoc.titleKhongTonTai'),
            });
            break;
    }
}

const messageErrorFind = (payload) => {
    switch (payload) {
        case 1:
            _swal.fire({
                icon: "warning",
                title: i18n.t('message.find.titleNotFind'),
                html: i18n.t('message.find.textErrorTrungTuyen'),
            });
            break;
        default:
            _swal.fire({
                icon: "warning",
                title: payload.title,
                html: `<h4 class='text-danger'>${payload.message}</h4>`,
            });
            break;
    }
}

const messageNotHaveFileDownload = () => {
    _swal.fire({
        icon: "warning",
        text: i18n.t('message.warning.haveNotFile'),
    })
}


export const _message = {
    notFill,
    messageSuccess,
    messageError,
    confirmDelete,
    messageDangKyFalse,
    trungKhaoSat,
    messageErrorServer,
    confirmEditThiSinh,
    confirmEditThiSinhExist,
    messageLoiDangKy,
    messageTrungNganh,
    messageDaTrungTuyen,
    messageErrorTraCuu,
    messageErrorCapNhapThongTin,
    messageErrorNhapHoc,
    messageErrorFind,
    messageNotHaveFileDownload
}